import React from 'react';
import Modal from 'react-modal';
import moment from 'moment';
import { Component } from '@poa/core';
import { observable } from 'mobx';
import { Observer } from 'mobx-react';
import { SingleDatePicker } from 'react-dates';
import { PrefetchSelect } from '../../profile-modal/tabs/profile-tab-form';
import Select from 'react-select';
import TimePicker from 'react-time-picker';


class _ProfileTransferModal extends React.Component {

  localState = observable({
    isOpen: this.props.isOpen,
    onRequestClose: this.props.onRequestClose,
    handleTransferCreate: this.props.handleTransferCreate,
    handleTransferUpdate: this.props.handleTransferUpdate,
    transfer: this.props.transfer,
    oldData: this.props.oldData,
    selectedTo: this.props.transfer ? this.props.transfer.to_user_id : null,
    selectedAccount: this.props.transfer ? this.props.transfer.account_id : null,
    selectedDate: this.props.transfer ? moment(this.props.transfer.transfer_date, 'DD.MM.YYYY HH:mm') : moment().utc(),
    isDatePickerOpen: false
  });

  onDateChange = event => {
    this.localState.selectedDate = moment(event._d);
  };

  onTimeChange = (value) => {
    this.localState.selectedDate = this.localState.selectedDate.hour(value.substring(0, 2)).minute(value.substring(3, 5));
  };

  componentDidUpdate(prevProps) {
    if (prevProps !== this.props) {
      this.localState.isOpen = this.props.isOpen;
      this.localState.onRequestClose = this.props.onRequestClose;
      this.localState.handleTransferCreate = this.props.handleTransferCreate;
      this.localState.handleTransferUpdate = this.props.handleTransferUpdate;
      this.localState.transfer = this.props.transfer;
      this.localState.oldData = this.props.oldData;
      this.localState.selectedTo = this.props.transfer ? this.props.transfer.to_user_id : null;
      this.localState.selectedAccount = this.props.transfer ? this.props.transfer.account_id : null;
      this.localState.selectedDate = this.props.transfer ? moment(this.props.transfer.transfer_date, 'DD.MM.YYYY HH:mm') : moment().utc();
      this.localState.isDatePickerOpen = false;
    }
  }

  render() {
    return (
      <Modal
        isOpen={this.localState.isOpen}
        onRequestClose={this.localState.onRequestClose}
        style={{
          overlay: {
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.75)'
          },
          content: {
            width: '50%',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            inset: '40% 0px 0px 50%'
          }
        }}>
        <div style={{ width: "100%", height: "100%", overflowY: "scroll", display: "flex", flexDirection: "column", justifyContent: "space-between" }}>

          <div>
            <div style={{ textAlign: 'center', width: '100%' }}>
              <h2>{this.localState.transfer ? "Обновить Трансфер" : "Создать Новый Трансфер"}</h2>
            </div>

            <div>
              <div style={{
                fontSize: '14px',
                fontWeight: '400',
                color: '#161021',
                marginTop: '20px'
              }} >Аккаунт:</div>
              <Select
                key={`0account`}
                value={this.localState.selectedAccount}
                onChange={e => this.localState.selectedAccount = e.value}
                options={this.localState.oldData.accounts_list}
                isSearchable={true}
                isClearable={false}
              />
              <div style={{
                fontSize: '14px',
                fontWeight: '400',
                color: '#161021',
                marginTop: '20px'
              }} >К кому:</div>
              <PrefetchSelect
                key={`0operator_to`}
                editMode={true}
                current={this.localState.selectedTo}
                type='transfer_operators'
                onChange={value => this.localState.selectedTo = value} />

              <div style={{
                fontSize: '14px',
                fontWeight: '400',
                color: '#161021',
                marginTop: '20px'
              }} >Дата трансфера:</div>
              <Observer>
                {() => (<div className='picker-wrapper'>
                  <SingleDatePicker
                    block
                    isOutsideRange={() => false}
                    placeholder='Виберите дату'
                    focused={this.localState.isDatePickerOpen}
                    displayFormat='DD.MM.YYYY'
                    date={this.localState.selectedDate}
                    onDateChange={this.onDateChange}
                    onFocusChange={() => this.localState.isDatePickerOpen = !this.localState.isDatePickerOpen}
                  />
                </div>)}
              </Observer>

              <div style={{
                fontSize: '14px',
                fontWeight: '400',
                color: '#161021',
                marginTop: '20px',
                marginBottom: '5px'
              }} >Время трансфера:</div>
              <Observer>
                {() => (
                  <div className='picker-wrapper'>
                    <TimePicker
                      className='time_picker'
                      onChange={this.onTimeChange}
                      value={moment(this.localState.selectedDate).format('HH:mm')}
                      disableClock={true}
                      openClockOnFocus={false}
                      format='HH:mm'
                    />
                  </div>
                )}
              </Observer>
            </div>
          </div>

          <div style={{
            display: 'flex',
            justifyContent: 'space-around',
            marginTop: '20px'
          }} >
            <button
              type='button'
              style={{
                backgroundColor: '#fff',
                color: 'red',
                fill: 'red',
                padding: '0',
                borderRadius: '6px',
                paddingLeft: "8px",
                paddingRight: "8px",
                height: "35px",
                border: "1px solid red",
                minWidth: "150px",
                width: '45%'
              }}
              onClick={this.localState.onRequestClose}
            >
              Закрыть
            </button>
            <button
              type='button'
              style={{
                backgroundColor: '#1ca26a',
                color: '#fff',
                fill: '#fff',
                padding: '0',
                borderRadius: '6px',
                paddingLeft: "8px",
                paddingRight: "8px",
                height: "35px",
                border: "1px solid #1ca26a",
                minWidth: "150px",
                width: '45%',
                fontWeight: '600'
              }}
              onClick={
                this.localState.transfer
                  ? () => this.localState.handleTransferUpdate(
                    this.localState.selectedAccount,
                    this.localState.selectedTo,
                    this.localState.selectedDate.format('DD.MM.YYYY HH:mm'),
                    this.localState.transfer.id,
                    this.localState.oldData.id)
                  : () => this.localState.handleTransferCreate(
                    this.localState.selectedAccount,
                    this.localState.selectedTo,
                    this.localState.selectedDate.format('DD.MM.YYYY HH:mm'),
                    this.localState.oldData.id)}
            >
              {this.localState.transfer ? "Обновить" : "Создать"}
            </button>
          </div>
        </div>
      </Modal>
    );
  };
}

export const ProfileTransferModal = Component()(_ProfileTransferModal);